import { apiClient, companyUrl, borderUrl } from '../http-common';
export function get(payload) {
    let endpoint = `${companyUrl}/tenants`;
    if (payload) {
        endpoint = `${companyUrl}/tenant/${payload.id}`;
    }
    return new Promise((resolve, reject) => {
        apiClient.get(endpoint).then((response) => {
            if (response.status === 200) {
                resolve(response.data);
            }
        });
    });
}
export function post(payload) {
    return new Promise((resolve, reject) => {
        apiClient.post(`${companyUrl}/tenant/create`, payload).then((response) => {
            if (response.status === 200) {
                resolve(response.data);
            }
        });
    });
}
export function put(payload) {
    return new Promise((resolve, reject) => {
        apiClient.put(`${companyUrl}/tenant/${payload.id}`, payload).then((response) => {
            if (response.status === 200) {
                resolve(response.data);
            }
        });
    });
}
export function getBorders() {
    return new Promise((resolve, reject) => {
        apiClient.get(`${borderUrl}s`).then((response) => {
            if (response.status === 200) {
                resolve(response.data);
            }
        });
    });
}
export function getPreBookings() {
    return new Promise((resolve, reject) => {
        apiClient.get(`${companyUrl}/pre-bookings`).then((response) => {
            if (response.status === 200) {
                resolve(response.data);
            }
        });
    });
}
